import { AppCounters, Application } from 'src/routes/root'

import { AppSettings } from './apiClient/getAppSettings'

const enum UIActions {
    STORE_APPLICATIONS = 'STORE_APPLICATIONS',
    UPDATE_APP_COUNTERS = 'UPDATE_APP_COUNTERS',
    TOGGLE_SENSITIVE_CONTENT = 'TOGGLE_SENSITIVE_CONTENT',
    STORE_APPLICATION_SETTINGS = 'STORE_APPLICATION_SETTINGS',
}

interface StoreApplicationsAction {
    type: UIActions.STORE_APPLICATIONS
    payload: Application[]
}

interface UpdateAppCountersAction {
    type: UIActions.UPDATE_APP_COUNTERS
    payload: AppCounters
}

interface ToggleSensitiveContentAction {
    type: UIActions.TOGGLE_SENSITIVE_CONTENT
}

interface StoreApplicationSettingsAction {
    type: UIActions.STORE_APPLICATION_SETTINGS
    payload: AppSettings
}

export type UIAction =
    | StoreApplicationsAction
    | UpdateAppCountersAction
    | ToggleSensitiveContentAction
    | StoreApplicationSettingsAction

export default UIActions
